import { render, staticRenderFns } from "./DistributeDataCard.vue?vue&type=template&id=17eb56fc&scoped=true"
import script from "./DistributeDataCard.vue?vue&type=script&lang=js"
export * from "./DistributeDataCard.vue?vue&type=script&lang=js"
import style0 from "./DistributeDataCard.vue?vue&type=style&index=0&id=17eb56fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb56fc",
  null
  
)

export default component.exports